import axios from 'axios';
import { TRUSTED } from '../../constants/account-information';

export const getAccountInformation = () =>
  axios
    .get('/v2/payments/account-simple')
    .then((response) => {
      if (response.status === 204) {
        return {
          status: 200,
          data: undefined,
        };
      }
      return response;
    })
    .catch(() => {
      return {
        status: 200,
        data: {
          limitRemaining: Number.MAX_VALUE,
          trustLevel: TRUSTED,
          isVerificationRequested: false,
        },
      };
    });

export const requestMerchantVerification = async (data) => {
  if (!data) {
    throw new Error('No data provided');
  }

  const request = {
    billToAddress: {
      name: data.name,
      company: data.company,
      phone: data.phone,
      line1: data.line1,
      line2: data.line2,
      city: data.city,
      state: data.state,
      postalCode: data.postalCode,
      countryCode: data.countryCode,
    },
    website: data.website,
    comment: data.comment,
  };

  return axios.post('/v2/payments/request-limit-increase', request);
};

/**
 * Start the identity verification process with Auctane Pay.
 * @returns {Promise<{ verificationUrl: string, identityProvider: string, plaidLinkToken: string }>} Axios promise for the API call.
 */
export const startAuctanePayIdentityVerification = async () => {
  return axios.post('/v2/payments/idv', {});
};
